// extracted by mini-css-extract-plugin
export var productGallery = "product-gallery-module--product-gallery--c1c94";
export var productGalleryImg = "product-gallery-module--product-gallery-img--d1556";
export var productGalleryImgWrapper = "product-gallery-module--product-gallery-img-wrapper--d5f3e";